import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPharmacyNotesNew } from '../../../../../redux/notes/getNotesReducer';
import { MODAL } from '../../../constants';
import { ModalContext } from '../PharmacyModalContent';
import NotesListComponent from './components/NotesListComponent';

const NotesList = () => {
  const { setModalContent, pharmacyId } = React.useContext(ModalContext);
  const { notes, isFetching } = useSelector((state) => state.getNotes);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPharmacyNotesNew(pharmacyId));
  }, [dispatch, pharmacyId]);

  const addNotesRedirectHandler = () => setModalContent(MODAL.ADD_NOTE);

  return (
    <NotesListComponent
      isFetching={isFetching}
      notes={notes}
      handleAddNote={addNotesRedirectHandler}
    />
  );
};

export default NotesList;
